// ** Reducers Imports

import layout from './layout'
import appCommon from '../common/store'
import eventApp from '../store/event'

const rootReducer = {
  layout,
  appCommon,
  eventApp
}

export default rootReducer
